import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";
import { Utils } from "src/modules/utils/shared/utils";
import { FrontendFieldDataType } from "./frontend-field-datatype.enum";
import { FrontendFieldType } from "./frontend-field-type.enum";

export enum TableCellType {
    text,
    int,
    decimal,
    yesNo,
    date,
    dateTime,
    color,
    button,
    byteSize,
    duration,
    durationNanos,
    link,
    icon,
    image
}

export namespace TableCellType {
    export function convertValue(value: any, type: TableCellType): any {
        switch (type) {
            case TableCellType.int:
                return Utils.restrictDecimalDigits(Utils.toNumber(value), 0);
            case TableCellType.decimal:
                return Utils.toNumber(value);
            case TableCellType.yesNo:
                return Utils.toBool(value);
            case TableCellType.date:
                return Utils.isString(value) ? new Date(value as string) : value;
            case TableCellType.dateTime:
                return Utils.isString(value) ? new Date(value as string) : value;
            default:
                return value;
        }
    }

    export function toGenericDataType(type: TableCellType): GenericDataType {
        switch (type) {
            case TableCellType.text:
                return GenericDataType.string;
            case TableCellType.int:
            case TableCellType.byteSize:
            case TableCellType.duration:
            case TableCellType.durationNanos:
                return GenericDataType.int;
            case TableCellType.decimal:
                return GenericDataType.decimal;
            case TableCellType.yesNo:
                return GenericDataType.bool;
            case TableCellType.date:
                return GenericDataType.date;
            case TableCellType.dateTime:
                return GenericDataType.dateTime;
            default:
                return GenericDataType.object;
        }
    }

    export function toFrontendFieldType(type: TableCellType): FrontendFieldType {
        switch (type) {
            case TableCellType.text:
                return FrontendFieldType.text;
            case TableCellType.int:
            case TableCellType.byteSize:
            case TableCellType.duration:
            case TableCellType.durationNanos:
                return FrontendFieldType.int;
            case TableCellType.decimal:
                return FrontendFieldType.decimal;
            case TableCellType.yesNo:
                return FrontendFieldType.checkBox;
            case TableCellType.date:
                case TableCellType.dateTime:
                return FrontendFieldType.datePicker;
            default:
                return FrontendFieldType.text;
        }
    }

}
